import jQuery from "jquery";
const $ = jQuery;
window.$ = $;